import * as XLSX from 'xlsx';
import Api from '../Auth/Api';

export const exportarUsuariosExcel = async (token) => {
    const response = await Api.get('api/exportar-usuarios', {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    const usuarios = response.data?.usuarios || [];

    if (!usuarios.length) {
        throw new Error('Nenhum usuário encontrado para exportação.');
    }

    const worksheet = XLSX.utils.json_to_sheet(usuarios);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Usuários');

    const dataArquivo = new Date().toISOString().split('T')[0];
    XLSX.writeFile(workbook, `usuarios_cadastrados_${dataArquivo}.xlsx`);

    return {
        total: usuarios.length,
        geradoEm: response.data?.gerado_em || null,
    };
};
